import React, { useState, useEffect } from 'react';
import './Navigation.scss'; // Assuming you'll have a SCSS file for styling

const Navigation = () => {
    // State to control the visibility of the navigation block based on scroll
    const [isVisible, setIsVisible] = useState(false);
    // State to manage which navigation button is currently active
    const [activeButton, setActiveButton] = useState('Главное'); // Default initial active button

    // Mapping of URL paths to navigation button names
    const pathMap = {
        '/': 'Главное',
        '/team': 'Команда',
        '/career': 'Карьера',
        // For #feedback, we'll handle it a bit differently as it's an anchor
        // If the URL contains #feedback, we can also set it active.
    };

    // Effect to handle scroll events for visibility
    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset >= 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        // Set the active button based on the current URL path when the component mounts
        const currentPath = window.location.pathname;
        const currentHash = window.location.hash;

        if (currentHash === '#feedback') {
            setActiveButton('Заявка');
        } else if (pathMap[currentPath]) {
            setActiveButton(pathMap[currentPath]);
        } else {
            // Fallback for paths not explicitly mapped, e.g., if on /smartcon, default to Главное
            setActiveButton('Главное');
        }

        document.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            document.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Function to handle clicks on navigation buttons and set the active one
    const handleButtonClick = (buttonName) => {
        setActiveButton(buttonName);
        // In a real application with routing (e.g., React Router),
        // you would use a navigation function here like history.push() or navigate()
        // For now, we're just updating the active state and letting the <a> tag handle navigation.
    };

    return (
        <div className="navigation-wrapper">
            <div className={`navigation-block ${isVisible ? '' : 'hide'}`}>
                <a href="/" onClick={() => handleButtonClick('Главное')}>
                    <div className={`nav-btn ${activeButton === 'Главное' ? 'nav-btn_active' : ''}`}>Главное</div>
                </a>
                <a href="team" onClick={() => handleButtonClick('Команда')}>
                    <div className={`nav-btn ${activeButton === 'Команда' ? 'nav-btn_active' : ''}`}>Команда</div>
                </a>
                <a href="career" onClick={() => handleButtonClick('Карьера')}>
                    <div className={`nav-btn ${activeButton === 'Карьера' ? 'nav-btn_active' : ''}`}>Карьера</div>
                </a>
                <a href="#feedback" onClick={() => handleButtonClick('Заявка')}>
                    <div className={`nav-btn nav-btn_white ${activeButton === 'Заявка' ? 'nav-btn_active' : ''}`}>Заявка</div>
                </a>
            </div>
        </div>
    );
};

export default Navigation;